var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgYoga = function SvgYoga(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2142 18.7539L19.2857 21.0602C19.2857 21.0602 24.1071 22.0842 24.1071 24.5197C24.1071 26.2494 21.9642 26.2494 21.9642 26.2494H16.25L13.4375 24.6869",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7835 18.7539L10.712 21.0602C10.712 21.0602 5.89062 22.0842 5.89062 24.5197C5.89062 26.2494 8.03347 26.2494 8.03347 26.2494H10.6228L13.4353 24.6869L16.8728 22.4994",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 19.9076C3.75 19.9076 6.42857 19.3311 8.03571 18.7545C9.64286 10.6824 14.4642 11.259 15 11.259C15.5358 11.259 20.3571 10.6824 21.9642 18.7545C23.5714 19.3311 26.25 19.9076 26.25 19.9076",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.75C16.3807 8.75 17.5 7.63071 17.5 6.25C17.5 4.86929 16.3807 3.75 15 3.75C13.6192 3.75 12.5 4.86929 12.5 6.25C12.5 7.63071 13.6192 8.75 15 8.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoga, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Yoga.3784fb6b.svg";
export { ForwardRef as ReactComponent };